import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { SubjectEnum, SubjectModel } from "@generativ/much-smarter-models";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "../../environments/environment";
import { ErrorHandlerService } from "../core/services/error-handler.service";

@Injectable({ providedIn: 'root' })
export class SubjectService {
  subjects: string[] = [];
  subjectsEnum = SubjectEnum;

  private subjectStudentURL = environment.msStudentApiUrl + "subjects/topics/";

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) {}

  public getSubjects(): Observable<SubjectModel[]> {
    return this.http
      .get<SubjectModel[]>(this.subjectStudentURL)
      .pipe(catchError(this.errorHandlerService.handleError));
  }
}
